import { IntEnumConditions, StringConditions } from '@nirvana/shared/dtos/types/shared/filters';
import { ViewConfiguration } from '../../../../grid/gridView/types';
import { ViewType } from '../../integrityMonitorRulesSmartViews/types';
import { ColumnDetails } from '../../../../grid/types/common';
import {
  IntegrityMonitorEntityType,
  IntegrityMonitorPlatform,
  IntegrityMonitorSeverity,
} from '../../../common/utils/types';
import _ from 'lodash';

export enum GridActions {
  NEW_RULE = 'newRule',
  NEW_RULE_SET = 'newRuleSet',
  ASSIGN_RULES_TO_RULE_SETS = 'assignToRuleSets',
  UNASSIGN_RULES_FROM_RULE_SETS = 'unassignRulesFromRuleSets',
  DELETE_RULES = 'deleteRules',
  DELETE_RULE = 'deleteRule',
  CORRECT_RULE = 'correctRule',
}

export enum IntegrityMonitorScopeType {
  OS = 1,
  APPLICATION,
  CUSTOM,
}

export enum IntegrityMonitorConfigurationStatus {
  STATUS_UNCONFIGURED = 1,
  STATUS_CONFIGURED_OK,
  STATUS_SOURCE_UPDATED,
  STATUS_SOURCE_DELETED,
}

export enum BooleanOption {
  NEGATIVE,
  POSITIVE,
}

export interface IntegrityMonitorRuleGridItem {
  _id: string;
  templateId?: string | null;
  version: number;
  companyId?: string | null;
  ruleName: string;
  description: string | null;
  scopeType: IntegrityMonitorScopeType;
  platform: IntegrityMonitorPlatform;
  severity: IntegrityMonitorSeverity;
  isDefaultRule: boolean;
  createdOn: Date | null;
  lastModifiedOn: Date;
  realTimeMonitoring: boolean;
  configurationStatus: IntegrityMonitorConfigurationStatus;
  ruleSetIds: Array<string>;
  stringVariables: Array<IntegrityMonitorRuleStringVariable>;
  entities: Array<IntegrityMonitorRuleEntity>;
  mitreIds: Array<string>;
}

export interface IntegrityMonitorRuleStringVariable {
  key: string;
  value: string;
}

export interface IntegrityMonitorRuleEntity {
  entityType: IntegrityMonitorEntityType;
  key: string;
  attributes: Array<string>;
  actions: Array<string>;
}

export enum Column {
  RULE_NAME,
  DESCRIPTION,
  ENTITY_TYPE,
  PLATFORM,
  SEVERITY,
  RULE_TYPE,
  CREATED_ON,
  LAST_MODIFIED_ON,
  STATUS,
  REAL_TIME_MONITORING,
  VERSION,
  CONFIG_STATUS,
  INLINE_ACTIONS,
}

export enum ColumnKeys {
  RULE_NAME = 'ruleName',
  DESCRIPTION = 'description',
  ENTITY_TYPE = 'entityType',
  PLATFORM = 'platform',
  SEVERITY = 'severity',
  RULE_TYPE = 'isDefaultRule',
  CREATED_ON = 'createdOn',
  LAST_MODIFIED_ON = 'lastModifiedOn',
  STATUS = 'ruleSetIds',
  REAL_TIME_MONITORING = 'realTimeMonitoring',
  VERSION = 'version',
  CONFIG_STATUS = 'configurationStatus',
  INLINE_ACTIONS = 'inlineRowActions',
}

export interface Filter {
  ruleName?: StringConditions;
  scopeType?: IntEnumConditions;
  entityType?: IntEnumConditions;
  platform?: IntEnumConditions;
  severity?: IntEnumConditions;
  isDefaultRule?: IntEnumConditions;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export const IM_RULES_DISPLAYED_FILTERS = [
  { [ColumnKeys.RULE_NAME]: { contains: '' } },
  { [ColumnKeys.ENTITY_TYPE]: { in: [] } },
  { [ColumnKeys.SEVERITY]: { in: [] } },
];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.RULE_NAME, ColumnKeys.ENTITY_TYPE, ColumnKeys.SEVERITY];

export const DISPLAYED_COLUMNS_RULES = _.range(Object.keys(Column).length / 2);
export const DISPLAYED_COLUMNS_RULES_NO_ACTIONS = _.range(Object.keys(Column).length / 2 - 2);

export interface IntegrityMonitorRulesGridAllRulesGetRowsResponse {
  rawEvents: Array<IntegrityMonitorRuleGridItem>;
}

export interface PartialIntegrityMonitorRulesGridWebComponentSchema {
  allColumnDetails: Array<ColumnDetails<Column, ColumnKeys>>;
  defaultViewProps: ViewConfiguration<Column, ColumnKeys, ViewType>;
  predefinedFiltersKeys: Array<ColumnKeys>;
}

export interface IntegrityMonitorRulesGridWebComponentSchema
  extends PartialIntegrityMonitorRulesGridWebComponentSchema {
  activeViewId: string;
  activeView: ViewConfiguration<Column, ColumnKeys, ViewType>;
  ruleIdsFilter: Array<string>;
}

export enum IntegrityMonitoringGridEvents {
  CLICK_ON_DEFAULT_RULE_NAME = 'clickOnDefaultRuleName',
  CLICK_ON_CUSTOM_RULE_NAME = 'clickOnCustomRuleName',
}
